(() => {
  const ratingSelector = '.loox-rating';
  const labelAttributes = ['aria-label', 'title'];
  const pendingRatings = new Set();
  let updateQueued = false;

  // Loox adds these English labels after Liquid has rendered. Keep every score
  // and count intact, correcting only the English review noun. Loox also uses
  // the short count label on the widget and each star's SVG <title>.
  function correctReviewNoun(value) {
    const correctedLabel = value.replace(
      /^(\s*)([\d,]+)(\s+)(reviews?)(\s*)$/i,
      (label, leading, count, spacing, noun, trailing) =>
        leading + correctCountPhrase(count, spacing, noun) + trailing
    );
    return correctedLabel.replace(
      /(Rated\s+[\d.,]+\s+out of\s+[\d.,]+\s+stars?\s+based on\s+)([\d,]+)(\s+)(reviews?)\b/gi,
      (sentence, prefix, count, spacing, noun) => prefix + correctCountPhrase(count, spacing, noun)
    );
  }

  function correctCountPhrase(count, spacing, noun) {
    const singular = Number(count.replaceAll(',', '')) === 1;
    const correctedNoun = singular ? noun.replace(/s$/i, '') : noun.replace(/s?$/i, 's');
    return count + spacing + correctedNoun;
  }

  function correctLabels(element) {
    for (const attribute of labelAttributes) {
      const value = element.getAttribute(attribute);
      if (!value) continue;
      const corrected = correctReviewNoun(value);
      if (corrected !== value) element.setAttribute(attribute, corrected);
    }
  }

  function updateRating(rating) {
    if (!rating.isConnected) return;
    correctLabels(rating);
    rating.querySelectorAll('[aria-label], [title]').forEach(correctLabels);

    const textNodes = document.createTreeWalker(rating, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = textNodes.nextNode())) {
      const corrected = correctReviewNoun(node.nodeValue);
      if (corrected !== node.nodeValue) node.nodeValue = corrected;
    }
  }

  function queueRating(rating) {
    if (!rating) return;
    pendingRatings.add(rating);
    if (updateQueued) return;
    updateQueued = true;
    queueMicrotask(() => {
      updateQueued = false;
      const ratings = [...pendingRatings];
      pendingRatings.clear();
      ratings.forEach(updateRating);
    });
  }

  function findRatings(node) {
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    queueRating(node.closest(ratingSelector));
    node.querySelectorAll(ratingSelector).forEach(queueRating);
  }

  function initialize() {
    document.querySelectorAll(ratingSelector).forEach(queueRating);

    // Also covers asynchronously loaded Loox widgets, search results and theme
    // section replacements without changing their review data or star display.
    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        const target = mutation.target.nodeType === Node.ELEMENT_NODE
          ? mutation.target
          : mutation.target.parentElement;
        if (target) queueRating(target.closest(ratingSelector));
        if (mutation.type === 'childList') mutation.addedNodes.forEach(findRatings);
      }
    }).observe(document.documentElement, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: labelAttributes,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
